export const APP_VERSION = process.env.REACT_APP_QA_MOBILE_APP_VERSION || '1.36.0';
